export const KPH_PER_METERS_PER_SECOND = 3.6;

export const getKmPerHourByMetersPerSecond = (metersPerSecond: number): number => metersPerSecond * KPH_PER_METERS_PER_SECOND;
